export const handleBookCall = () =>
  window.open(
    "https://calendly.com/sven-badalyan/meeting-with-sven-badalyan?hide_event_type_details=1&hide_gdpr_banner=1",
    "_blank",
  );
